<onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="facade.sendingNationalityTaxAndEmploymentInformation$ | async"
  (back)="facade.goToPreviousStep()"
  (forward)="submit()"
>
  <p class="zero-text p-huge-med">{{ 'onboarding.nationality.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.nationality.text' | transloco }}</p>
  <web-design-system-select
    [items]="nationalities$ | async"
    [placeholder]="'onboarding.nationality.headline' | transloco"
    (selectItem)="selectNationality($event)"
  />
  <p class="zero-text p-huge-med mt-5">{{ 'onboarding.nationality.tax.headline' | transloco }}</p>
  <web-design-system-select
    [items]="taxCountries$ | async"
    [placeholder]="'onboarding.nationality.tax.placeholder' | transloco"
    (selectItem)="selectTaxCountry($event)"
  />

  @if (taxCountry$ | async; as taxCountry) {
    @if (isTaxCountryGermany$ | async) {
      <div class="mt-3 zero-text p-small-reg">
        @if (shouldEnterTinIndependently$ | async) {
          {{ 'onboarding.nationality.tax.acceptance' | transloco }}
          <ng-container *ngTemplateOutlet="baaderBankTooltip" />
          {{ 'onboarding.nationality.tax.independently.text' | transloco }}
          <br />
          {{ 'onboarding.nationality.tax.independently.pre' | transloco }}
          <a class="zero-text link" (click)="setIndependentlyEnterTin(false)">{{
            'onboarding.nationality.tax.independently.link' | transloco
          }}</a>
        } @else {
          {{ 'onboarding.nationality.tax.acceptance' | transloco }}
          <ng-container *ngTemplateOutlet="baaderBankTooltip" />
          {{ 'onboarding.nationality.tax.automatically.text' | transloco }}
          <br />
          {{ 'onboarding.nationality.tax.automatically.pre' | transloco }}
          <a class="zero-text link" (click)="setIndependentlyEnterTin(true)">{{
            'onboarding.nationality.tax.automatically.link' | transloco
          }}</a>
        }
      </div>
      @if (shouldEnterTinIndependently$ | async) {
        <web-design-system-input
          class="d-block mt-3"
          [label]="'onboarding.nationality.tax.tin' | transloco"
          [value]="tin$ | async"
          [isValid]="tin$ | async | tin: taxCountry"
          [error]="tin$ | async | tinError: taxCountry"
          (valueChange)="handleTinChange($event)"
        />
      }
    } @else {
      <div class="d-flex justify-content-between align-items-center mt-3 gap">
        <div>
          {{
            'onboarding.nationality.tax.not-germany.hint'
              | transloco
                : {
                    country:
                      ('onboarding.nationality.tax.not-germany.' + taxCountry | transloco) !==
                      'onboarding.nationality.tax.not-germany.' + taxCountry
                        ? ('onboarding.nationality.tax.not-germany.' + taxCountry | transloco) + (taxCountryName$ | async)
                        : (taxCountryName$ | async),
                  }
          }}
        </div>
        <web-design-system-input
          class="d-block"
          [label]="'onboarding.nationality.tax.tin' | transloco"
          [value]="tin$ | async"
          [isValid]="tin$ | async | tin: taxCountry"
          (valueChange)="handleTinChange($event)"
        />
      </div>
      <div class="mt-3">
        {{
          'onboarding.nationality.tax.not-germany.baader'
            | transloco
              : {
                  country:
                    ('onboarding.nationality.tax.not-germany.' + taxCountry | transloco) !==
                    'onboarding.nationality.tax.not-germany.' + taxCountry
                      ? ('onboarding.nationality.tax.not-germany.' + taxCountry | transloco) + (taxCountryName$ | async)
                      : (taxCountryName$ | async),
                }
        }}
      </div>
    }
  }

  @if (isSecondTaxCountryVisible$ | async) {
    <div class="d-flex justify-content-between flex-wrap gap mt-4">
      <web-design-system-select
        class="d-block flex-grow-1"
        [items]="taxCountries2$ | async"
        [placeholder]="'onboarding.nationality.tax.country2' | transloco"
        [hasError]="isSecondTaxCountryUSA$ | async"
        (selectItem)="selectSecondTaxCountry($event)"
      />
      <div class="d-flex align-items-center gap">
        <web-design-system-input
          [label]="'onboarding.nationality.tax.tin' | transloco"
          [value]="secondTin$ | async"
          [isValid]="secondTin$ | async | tin: (secondTaxCountry$ | async)"
          (valueChange)="handleSecondTinChange($event)"
        />
        <web-design-system-icon class="cursor-pointer" name="trash" (click)="removeSecondTaxCountry()" />
      </div>
    </div>
    @if (isSecondTaxCountryUSA$ | async) {
      <div class="text-center zero-text p-xsmall-reg course-red mt-2">{{ 'onboarding.nationality.tax.us-citizen' | transloco }}</div>
    }
    @if (secondTin$ | async | tinError: (secondTaxCountry$ | async); as error) {
      <div class="text-center zero-text p-xsmall-reg course-red mt-2">{{ error }}</div>
    }
    @if (isThirdTaxCountryVisible$ | async) {
      <div class="d-flex justify-content-between flex-wrap gap mt-4">
        <web-design-system-select
          class="d-block flex-grow-1"
          [items]="taxCountries3$ | async"
          [placeholder]="'onboarding.nationality.tax.country3' | transloco"
          [hasError]="isThirdTaxCountryUSA$ | async"
          (selectItem)="selectThirdTaxCountry($event)"
        />
        <div class="d-flex align-items-center gap">
          <web-design-system-input
            [label]="'onboarding.nationality.tax.tin' | transloco"
            [value]="thirdTin$ | async"
            [isValid]="thirdTin$ | async | tin: (thirdTaxCountry$ | async)"
            (valueChange)="handleThirdTinChange($event)"
          />
          <web-design-system-icon class="cursor-pointer" name="trash" (click)="removeThirdTaxCountry()" />
        </div>
      </div>
      @if (isThirdTaxCountryUSA$ | async) {
        <div class="text-center zero-text p-xsmall-reg course-red mt-2">{{ 'onboarding.nationality.tax.us-citizen' | transloco }}</div>
      }
      @if (thirdTin$ | async | tinError: (thirdTaxCountry$ | async); as error) {
        <div class="text-center zero-text p-xsmall-reg course-red mt-2">{{ error }}</div>
      }
    } @else {
      <a
        class="d-block zero-text link mt-3"
        [class.disabled]="(secondTaxCountry$ | async) === null || (secondTaxCountry$ | async) === undefined"
        (click)="addThirdTaxCountry()"
      >
        {{ 'onboarding.nationality.tax.add-tax-country' | transloco }}
      </a>
    }
  } @else {
    <a
      class="d-block zero-text link mt-3"
      [class.disabled]="(taxCountry$ | async) === null || (taxCountry$ | async) === undefined"
      (click)="addSecondTaxCountry()"
    >
      {{ 'onboarding.nationality.tax.add-tax-country' | transloco }}
    </a>
  }
  <p class="zero-text p-huge-med mt-5">{{ 'onboarding.nationality.self-employed.headline' | transloco }}</p>
  <web-design-system-select
    [items]="selfEmployedOptions$ | async"
    [placeholder]="'onboarding.nationality.self-employed.placeholder' | transloco"
    (selectItem)="selectSelfEmployed($event)"
  />
  @if ((selfEmployed$ | async) === 1) {
    <web-design-system-select
      class="d-block mt-3"
      [items]="branches$ | async"
      [placeholder]="'onboarding.nationality.self-employed.branch' | transloco"
      (selectItem)="selectBranch($event)"
    />
  }
</onboarding-container>

<ng-template #baaderBankTooltip>
  <span class="text-underline-dotted" [ngbTooltip]="'onboarding.nationality.tax.baader-bank.tooltip' | transloco" triggers="hover click">
    {{ 'onboarding.nationality.tax.baader-bank.label' | transloco }}
  </span>
</ng-template>
